
import Header from "./Compartido/Header";
import BrandsSection from "./Compartido/BrandsSection";
import Hero from "./Rewards/Hero";
import Buscador from "./Inicio/Buscador";
import Aspectos from "./Rewards/Aspectos";
import Footer from "./Compartido/Footer";

const Rewards = (props) => {
    return (
        <>
            <div className="rewards page-rewards">
                <Header
                    pagina="globals"
                    config={props.websgrupo}
                    lang={props.lang}
                    meta_titulo={props.meta_titulo}
                    meta_descripcion={props.meta_descripcion}
                    meta_keywords={props.meta_keywords}
                    ruta={props.ruta}
                    idiomas={props.idiomas}
                    destinos={props.destinos}
                    experiencias={props.experiencias}
                />
                <Hero
                    lang={props.lang}
                    config={props.websgrupo}
                    ruta={props.ruta}
                />
                <Buscador
                    lang={props.lang}
                    destinos={props.destinos}
                    capacidad_maxima={props.capacidad_maxima}
                />
                <Aspectos
                    lang={props.lang}
                    faqs={props.faqs}
                    config={props.websgrupo}
                    ruta={props.ruta}
                />
                <app-footer>
                    <BrandsSection
                        lang={props.lang}
                        marcas={props.marcas}
                        ruta={props.ruta}
                    />
                    <Footer
                        lang={props.lang}
                        config={props.websgrupo}
                    />
                </app-footer>
            </div>
        </>
    )
}

export default Rewards;
